import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
const BOOKING_PAGE_SIZE = 100;
const EMPTY_RESPONSE = {
    upcomingBookings: [],
    archivedBookings: [],
    upcomingOfferBookings: [],
    archivedOfferBookings: [],
};
const isBookingForPub = (booking, pubId) => { var _a, _b; return String((_b = (_a = booking === null || booking === void 0 ? void 0 : booking.pub_id) !== null && _a !== void 0 ? _a : booking === null || booking === void 0 ? void 0 : booking.pubId) !== null && _b !== void 0 ? _b : "") === String(pubId); };
const getVenueBookings = async (userId, pubId) => {
    const { data } = await API.post(`/api/v1/rbzo/users/${userId}/bookings?page=0&size=${BOOKING_PAGE_SIZE}`);
    const result = data === null || data === void 0 ? void 0 : data.data;
    if (!result)
        return EMPTY_RESPONSE;
    return {
        upcomingBookings: (result.upcoming_bookings || []).filter((booking) => isBookingForPub(booking, pubId)),
        archivedBookings: (result.archived_bookings || []).filter((booking) => isBookingForPub(booking, pubId)),
        upcomingOfferBookings: (result.upcoming_offer_bookings || []).filter((booking) => isBookingForPub(booking, pubId)),
        archivedOfferBookings: (result.archived_offer_bookings || []).filter((booking) => isBookingForPub(booking, pubId)),
    };
};
export const useVenueBookings = (pubId, enabled = true) => {
    const { customerData } = useCustomer();
    const userId = customerData === null || customerData === void 0 ? void 0 : customerData.id;
    return useQuery(["venueBookings", userId, pubId], () => getVenueBookings(userId, pubId), {
        enabled: enabled && !!userId && !!pubId,
        staleTime: 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
};
